import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { Button, Spinner } from "~/components-shared";
const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  z-index: 3;
  border-radius: 30px;
  border: 1px solid ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.borders.primary;
}};
  ${_ref2 => {
  let {
    $s,
    theme
  } = _ref2;
  return theme.spacing.resolve(theme, $s);
}};

  & > * {
    &:not(:first-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      &:before {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    &:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;

      &:before {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
`;
const ButtonGroup = _ref3 => {
  let {
    selected,
    options,
    s,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s
  }, rest), options.map(button => /*#__PURE__*/React.createElement(Button, {
    key: button.id,
    onClick: () => button.onClick(button.id),
    display: "inline-block",
    color: selected === button.id ? "translucentPrimary" : "transparent",
    fontSize: 3.5,
    s: {
      px: 4,
      py: 1.5
    },
    rounded: true,
    pulse: button.inProgress,
    outline: false
  }, button.inProgress && /*#__PURE__*/React.createElement(Spinner, {
    scale: 4,
    s: {
      mr: 1.5
    }
  }), button.title, !!button.count && ` (${button.count})`)));
};
export default ButtonGroup;